import { WarningAmberOutlined } from '@mui/icons-material';
import { Box, Tooltip } from '@mui/material';
import React from 'react';
import { useIntl } from 'react-intl';
import { formatTranslation } from 'intl';
import { levelMapWarningLabelKey } from 'intl/helpers/documentation';
import { getCanBeUsedAsMap } from 'components/documentation/model';
import { LevelMapWarning } from 'shared/domain/documentation/levelMap';
import { DocumentationBaseIds } from 'shared/types/documentation';
import { useIssueOverlayControls } from '../../../documentation/DocumentationDataGrid/components/IssueOverlayControls';
import { useGalleryContext } from '..';
import { identitySelector } from '../selectors';
import { mapInvalidFileWarningSx } from './styles';

/**
 * Warns on the preview bar that the shown documentation is a level's map but
 * cannot be drawn as one (PT-7117: any documentation may be a map; D3).
 */
export const MapInvalidFileWarning: React.FC = () => {
  const intl = useIntl();
  const [file] = useGalleryContext<DocumentationBaseIds>().useMainDisplayedFile(identitySelector);
  const { isUsedAsMap } = useIssueOverlayControls();
  const canBeDrawn = getCanBeUsedAsMap(file?.data?.extension, file?.imageConvertStatus);

  if (!file || !isUsedAsMap || canBeDrawn) {
    return null;
  }
  const message = formatTranslation(intl, levelMapWarningLabelKey(LevelMapWarning.notSuitable));
  return (
    <Tooltip title={message}>
      <Box sx={mapInvalidFileWarningSx} role='img' aria-label={message} data-qa='gallery_map_invalid_file_warning'>
        <WarningAmberOutlined />
      </Box>
    </Tooltip>
  );
};
